import { combineReducers } from 'redux';
import RouteMenuReducer from 'LIBRARY/Reducers/RouteMenuReducer';

const Reducers = combineReducers({
    RouteMenuReducer
});

export default Reducers;